// extracted by mini-css-extract-plugin
export default {"inner":"PointsManager_inner__+Nmpq"};